import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyStateBox, Header, NavHeader, Page } from '../../components';
import { IconWarning } from '../../assets/icons/icon-warning';

type ActionCreateTasksVariantsProps = {
  children: ReactNode[];
  listCount: number;
};

export const ActionCreateTasksVariants: React.FC<ActionCreateTasksVariantsProps> = ({ children, listCount }) => {
  const { t } = useTranslation('action');

  return (
    <Page
      isStickyHeader
      header={
        <>
          <NavHeader />
          <Header title={t('action.create.tasks.task')} />
        </>
      }
    >
      <div className="grid-list-24">
        {listCount ? (
          children
        ) : (
          <EmptyStateBox
            header={t('action.create.tasks.noVariants.header')}
            content={t('action.create.tasks.noVariants.content')}
            icon={<IconWarning />}
          />
        )}
      </div>
    </Page>
  );
};
